import { FormControl, InputLabel, MenuItem, Select, Button, Autocomplete, TextField, Tooltip, Snackbar, Alert, CircularProgress, Accordion, AccordionDetails, AccordionSummary, Stack } from "@mui/material";
import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import TPCheckbox from '../../TemplateProperties/TPCheckbox'
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { api } from "../../../redux/api";
import { treeActions } from "../../../redux/slices/treeSlice";
import { cloneDeep, debounce, isArray } from "lodash";
import Repository from "../../Repository/Repository";
import { eachDeep } from "deepdash-es/standalone";
import TableViewer from "./TableViewer";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import { SectionHeader } from "../Forms/SectionHeader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { debounceFunction } from "../../../utils/utilFunctions";
import dbQueryIcon from '../../../assets/icons/db_query.png';
import LightTooltip from "../../../commonComponents/LightTooltip";

function DatabaseRecordProperties() {
  const { t } = useTranslation();
  const [statementType, setStatementType] = useState("");
  const [dbSchema, setDbSchema] = useState(t('SELECT'));
  const [insertIfUpdateFails, setInsertIfUpdateFails] = useState(false);
  const [fieldUnchanged, setFieldUnchanged] = useState(false)
  const [connection , setConnection] = useState('');
  const [connectionInput, setConnectionInput] = useState('');
  const [columnSorted, setColumnSorted] = useState(false);
  const [includeNull, setIncludeNull] = useState(false);
  const [connectionOptions, setConnectionOptions] = useState([])
  const [showAlert, setShowAlert] = useState({message:'',isOpen:false,type:'success'})
  const [loadButton, setLoadButton] = useState(false)
  const [pdcModal, setPdcModal] = useState(null);
  const [enable,setEnable] = useState(false)
  const clickedSchemaButton = useRef();
  const [dbSchemaOptions, setDbSchemaOptions] = useState([])
  const [connLoading,setConnectionLoading] = useState(false);
  const [dbTableOptions,setDbTableOptions] = useState([])
  const [openTableViewer, setOpenTableViewer] = useState(false);
  const [ dbTableColumns, setDbTableColumns] = useState([]);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [dbConnected, setDbConnected] = useState(false);
  
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const { translatedData, selectedNode } = rightTree.tree[currentTab];
  const { PREDEFINED_CONNECTION } = rightTree.tree.templateHeader
  const { account, user } = useSelector(state => state.queryParams);
  const { pdc } = useSelector(state => state.treeData[parentScreen]);
  const [dbTable, setDbTable] = useState(t("EMPTY_COMBO"));

  const dispatch = useDispatch();
  const connectionLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isLoading || false)
  const connectedPDC = useSelector(state => state?.treeData?.[parentScreen]?.connectedPDC);
  const isError =  useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isError || false)
  const listUpdated = useSelector((state) => state.treeData.pdcListUpdated);

  const statementTypeOptions = [
    { title: t("LBL_LOOP_ONLY"), value: "loop_only" },
    { title: t("OPTION_RECORD_PROP_INSERT"), value: "INSERT" },
    { title: t("OPTION_RECORD_PROP_UPDATE"), value: "UPDATE" },
    { title: t("OPTION_RECORD_PROP_DELETE"), value: "DELETE" },
  ];
 
  const handleStatementTypeChange = (e) => {
    const { value } = e.target;
    setStatementType(value);
    
    if (selectedNode?.STATEMENT !== value)  updateHandler("STATEMENT", value);
    
    if( value === "loop_only"){
      setDbSchema(t('SELECT'));
      setDbTable(t('EMPTY_COMBO'));
      setDbTableOptions([t('EMPTY_COMBO')])
    }
  };

  const handleDbSchemaChange = (e,newVal) => {
    if(!newVal) return;

    setDbSchema(newVal);
    handleDatabaseTable(newVal);

    // if(newVal === t('SELECT') || newVal === null){
      setDbTable(t('EMPTY_COMBO'));
      setDbTableOptions([t('EMPTY_COMBO')])
    // } 
    if (selectedNode?.SCHEMA_NAME !== newVal) debounceChangeHandler("SCHEMA_NAME", newVal);
  };
  const handleDbTableChange = (e,newVal) => {
    if(!newVal) return;
    setDbTable(newVal);
  };
  const handleDatabaseTable = (value) => {
    const effectivePdcName = selectedNode?.PREDEFINED || PREDEFINED_CONNECTION;
    if (value && value !== t("SELECT")) {
      dispatch(
        api.endpoints.getDatabaseTableInfo.initiate(
          {
            account,
            user,
            direction: "OUT",
            pdc_name: effectivePdcName,
            schema_name: value,
          },
          {
            forceRefetch: true,
          }
        )
      ).then(res => {
        if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data?.database_table_list)){
          const list = res?.data?.data?.database_table_list;
          setDbTableOptions([t('EMPTY_COMBO'),...list])
        }else {
          const message = res?.data?.message;
          if (dbConnected) {
            setShowAlert({ message: message, isOpen: true, type: 'warning' })
          }
        }
      })
    }
  }
  const handleLoading  = (value) => {
    if (value) setConnectionLoading(true);
    else setTimeout(() => setConnectionLoading(false), 500)
  }

  const handleConnection = () => {
    if(PREDEFINED_CONNECTION !== connection){
      setDbSchemaOptions([t('SELECT')])
      setDbTableOptions([t('EMPTY_COMBO')])
    }
    
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: true, isError: false}}));
      setConnectionLoading(true)
      dispatch(
        api.endpoints.connect_to_selected_db.initiate(
          {
            account: account,
            user: user,
            direction: parentScreen === "inbound" ? "IN" : "OUT",
            pdc_name: encodeURIComponent(connection),
          },
          { forceRefetch: true }
        )
      )
        .then((res) => {
          if (
            ["success", "connected"].includes(
              res?.data?.message?.trim()?.toLowerCase()
            )
          ) {
            setDbConnected(true);
            setShowAlert({
              message:
                res?.data?.data?.toUpperCase() ||
                res?.data?.message?.toUpperCase(),
              isOpen: true,
              type: "success",
            });
            setConnectionLoading(false);

            const schemas = [];
            if (!schemas.length && connection) {
              dispatch(
                api.endpoints.getSchemaList.initiate(
                  {
                    account,
                    direction: "out",
                    pdc_name: connection,
                  },
                  {
                    forceRefetch: true,
                    subscribe: true,
                  }
                )
              ).then((res) => {
                if (clickedSchemaButton.current !== selectedNode?.key) return;
                if (
                  res?.data?.current_state === "SUCCESS" &&
                  isArray(res?.data?.data)
                ) {
                 const receivedSchemas = res?.data?.data || [];
                 const schemaSet = new Set(receivedSchemas);
                 if (selectedNode?.SCHEMA_NAME && !schemaSet.has(selectedNode.SCHEMA_NAME)) {
                   schemaSet.add(selectedNode.SCHEMA_NAME);
                 }
                 setDbSchemaOptions([t("SELECT"), ...Array.from(schemaSet)]);
                 if (selectedNode?.hasOwnProperty("SCHEMA_NAME") && selectedNode?.SCHEMA_NAME !== t("SELECT") && !res?.data?.data.includes(selectedNode?.SCHEMA_NAME)) {
                    setShowAlert({
                      message: t("LBL_SCHEMA_NOT_FOUND").replace(
                        "{0}",
                        selectedNode?.DESCRIPTION || null
                      ),
                      isOpen: true,
                      type: "warning",
                    });

                    setDbSchema(selectedNode?.SCHEMA_NAME || t("SELECT"));
                    setDbTable(t("EMPTY_COMBO"));
                    setDbTableOptions([t("EMPTY_COMBO")]);
                    setConnectionLoading(false);
                  }

                  if (res?.data?.data?.length === 1) {
                    if (selectedNode?.SCHEMA_NAME !== res?.data?.data?.[0])
                      debounceChangeHandler(
                        "SCHEMA_NAME",
                        res?.data?.data?.[0]
                      );
                    dispatch(
                      treeActions.setConnectedPDC({
                        data: {
                          CONNECTION: connection,
                          SCHEMA: receivedSchemas[0],
                        },
                      })
                    );
                  } else if (res?.data?.data?.length > 1) {
                    const schema = res?.data?.data?.filter(
                      (e) => e === selectedNode?.SCHEMA_NAME
                    )?.length
                      ? selectedNode?.SCHEMA_NAME
                      : t("SELECT");

                    setDbSchema(selectedNode?.SCHEMA_NAME || t("SELECT"));
                    handleDatabaseTable(schema);
                    dispatch(
                      treeActions.setConnectedPDC({
                        data: {
                          CONNECTION: connection,
                          SCHEMA: schemas?.[0],
                        },
                      })
                    );
                  }
                  handleLoading(false);
                  setLoadButton(true);
                  setEnable(true);
                } else {
                  const message = !isArray(res?.data?.data)
                    ? res?.data?.data
                    : res?.data?.message;
                  setShowAlert({
                    message: message,
                    isOpen: true,
                    type: "warning",
                  });
                }
              });
            } else if (schemas?.length && connection) {
              if (schemas?.length === 1) {
                if (selectedNode?.SCHEMA_NAME !== schemas?.[0])
                  debounceChangeHandler("SCHEMA_NAME", schemas?.[0]);
                dispatch(
                  treeActions.setConnectedPDC({
                    data: {
                      CONNECTION: connection,
                      SCHEMA: schemas?.[0],
                    },
                  })
                );
              }
              handleLoading(false);
              setLoadButton(true);
              setEnable(true);
            }
          } else {
            setDbConnected(false);
            setShowAlert({
              message:
                res?.data?.data || res?.data?.message || "Something went wrong",
              isOpen: true,
              type: "warning",
            });
            setConnectionLoading(false);
            dispatch(
              treeActions.setLoadingActions({
                screen: parentScreen,
                key: "SCHEMA_LOADING",
                data: { isLoading: false, isError: false },
              })
            );
          }
        })
        .catch((error) => {
          setDbConnected(false);
          setShowAlert({
            message: error.message || "Connection failed",
            isOpen: true,
            type: "error",
          });
          setConnectionLoading(false);
        });
  };
  const handleAlertClose = () => {
    setShowAlert({...showAlert,isOpen:false})
  }
  const handleChange = (key, value) => {
    
    const updatePdcConnectionInTemplateHeader = (headerKey, headerValue) => {
      const updatedHeader = cloneDeep(rightTree.tree.templateHeader);

      if (
        headerValue?.trim() === "" ||
        headerValue === "" ||
        headerValue === null ||
        headerValue === undefined
      ) {
        delete updatedHeader[headerKey];
      } else {
        updatedHeader[headerKey] = headerValue;
      }

      dispatch(
        treeActions.setRightTreeTemplateHeader({
          value: updatedHeader,
          screen: parentScreen,
        })
      );
    };

    if (value !== PREDEFINED_CONNECTION) {
      setLoadButton(false);
      setEnable(false);

      if (selectedNode?.[key] !== value) {
        let newSelectedNode = cloneDeep(selectedNode);
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
          if (objValue?.key === selectedNode?.key) {
            if (
              key === "PREDEFINED" &&
              (value?.trim() === "" ||
                value === "" ||
                value === null ||
                value === undefined)
            ) {
              if (objValue.hasOwnProperty("PREDEFINED")) {
                delete objValue.PREDEFINED;
              }
            } else if (key === "PREDEFINED") {
              objValue.PREDEFINED = value;
            }

            newSelectedNode = objValue;

            if (isArray(objValue?.children)) {
              return objValue.children;
            }
          }
        });

        dispatch(
          treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: updatedData,
          })
        );
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree?.currentTab,
            data: newSelectedNode,
          })
        );

        updatePdcConnectionInTemplateHeader("PREDEFINED_CONNECTION", value);
      }
    }
  }
  const updateHandler = (key, val) => {
    if (
      key !== "CONNECTION" &&
      key !== "PREDEFINED" &&
      key !== "SCHEMA_NAME" &&
      key !== "TABLE_NAME" &&
      key !== "STATEMENT" &&
      key !== 'UNIQUE' &&
      key !== 'ON_STATEMENT_ERROR_FLIP' &&
      key !== 'INCLUDE_NULL' &&
      key !== 'SORT_DB_COLUMNS' &&
      key !== 'DB_TABLE_COLUMNS'
    )
      return;
    const titleMapping = {
      INSERT: 'INTO',
      UPDATE: '',
      DELETE: ''
    }
  
    let newSelectedNode = cloneDeep(selectedNode);
    const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
      if (objValue?.key === selectedNode?.key) {
        if (key === "DB_TABLE_COLUMNS") {
          objValue.db_table_columns = val || [];
        } else if (key === "STATEMENT") {
          if (val !== 'loop_only') {
            objValue[key] = val;
            objValue.ICON_DISPLAY = 'QUERY';
            // For non-loop_only statements, set title based on schema/table or description
            if (objValue.SCHEMA_NAME && objValue.TABLE_NAME) {
              objValue.title = ` ${t('LBL_RECORD')} ${val}  ${titleMapping[objValue.STATEMENT]} ${objValue.TABLE_NAME}`;
            } else if (objValue.DESCRIPTION) {
              objValue.title = `${t('LBL_RECORD')} ${objValue.DESCRIPTION}`;
            } else {
              // If no description for non-loop_only statement, title should be empty
              objValue.title = `${t('LBL_RECORD')}`;
            }
          } else {
            // For loop_only: Use loop record value for title
            const loopRecordValue = objValue.LOOP_SOURCE_NAME || objValue.SOURCE_TYPE || objValue.TYPE;
            if (loopRecordValue && loopRecordValue !== t("SELECT")) {
              objValue.title = `${t('LBL_RECORD')} ${loopRecordValue}`;
            } else {
              objValue.title = `${t('LBL_RECORD')} ${objValue.DESCRIPTION || 'UNNAMED'}`;
            }
            objValue.ICON_DISPLAY = 'RECORD_LOOP';
  
            const propertiesToDelete = ['TABLE_NAME', 'SCHEMA_NAME', 'ON_STATEMENT_ERROR_FLIP', 'UNIQUE', 'STATEMENT'];
            if (objValue?.STATEMENT) delete objValue?.STATEMENT
            if (objValue.TABLE_NAME) {
              propertiesToDelete.forEach(prop => delete objValue[prop]);
          
            }
          }
        } else if (key === "TABLE_NAME") {
          if (val !== t("EMPTY_COMBO") && val !== null) {
            objValue[key] = val;
            if (objValue.STATEMENT && objValue.SCHEMA_NAME && val !== null) {
              objValue.title = ` ${t("LBL_RECORD")} ${objValue.STATEMENT}  ${
                titleMapping[objValue.STATEMENT]
              } ${val}`;
            }
          } else {
            delete objValue[key];
            objValue.title = `${t("LBL_RECORD")} ${objValue.DESCRIPTION || ''}`;
          }
        } else if (key === "SCHEMA_NAME") {
          if (val !== t("SELECT") && val !== null) {
            objValue[key] = val;
          } else {
            delete objValue[key];
            if (objValue.hasOwnProperty("TABLE_NAME"))
              delete objValue.TABLE_NAME;
            objValue.title = `${t("LBL_RECORD")} ${objValue.DESCRIPTION}`;
          }
        } else {
          if (key !== "DB_TABLE_COLUMNS")
            objValue[key] =
              typeof val === "boolean"
                ? String(val).toUpperCase()
                : String(val);
        }
        //set selnode to be same as modified obj
        newSelectedNode = objValue;

        if (isArray(objValue?.children)) {
          return objValue.children
        }
      } else {
        if (
          objValue?.ICON_DISPLAY &&
          [
          "DATABASE_FIELD", "DATABASE_FIELD_KEY", "DATABASE_FIELD_VALID", 
          "DATABASE_FIELD_VALID_KEY", "FIELD", "WARNING"
          ].includes(objValue.ICON_DISPLAY)
        ) {
          // if "Perfom INSERT if UPDATE fails" checkbox is false, delete "KEY" prop from all children fields.
          // if "Ignore Statement if field is unchanged" checkbox is false, delete "UNIQUE" prop from all children fields
          if (key === "ON_STATEMENT_ERROR_FLIP" && !val && objValue.KEY) delete objValue.KEY;
          if (key === "UNIQUE" && !val && objValue.UNIQUE) delete objValue.UNIQUE;
        }
      }
    });

    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree?.currentTab,
        data: newSelectedNode
      })
    )
  }
  const debounceChangeHandler = useCallback(debounce(updateHandler, 200), [
    rightTree.currentTab,
    rightTree.tree,
  ]);
 
  const handleTableViewer = () => {
    if (!dbConnected) {
      setOpenTableViewer(false);
      setShowAlert({
        message: t("BOX_YOU_ARE_NOT_CONNECTED_TO_DB"),
        isOpen: true,
        type: "warning",
      });
    }  else {
      setOpenTableViewer(true);
    }
  }

  const getConnections = () => {
    dispatch(api.endpoints.getAllPdcDetail.initiate({
        account: account,
        direction: parentScreen === "inbound" ? "in" : "out"
    }, {forceRefetch: true})).then(res => {
        if (res?.data?.current_state === 'ERROR' || !res?.data?.predefined_connections) {
            console.log(res?.data?.current_state);
        } else {
            const list = [];
            for (const [key, value] of Object.entries(res?.data?.predefined_connections)) {
                if (Object.values(value)[0]?.DATABASE_TYPE !== undefined)
                    list.push(Object.keys(value)[0]);
            }
            if(list.length)
              setConnectionOptions([t("SELECT"), ...list]);
            else
              setConnectionOptions([t("SELECT")]);
        }
    })
  }
 
  // useEffect(() => {
  //   getConnections();
  //   const connections = Object?.keys(pdc || {});
  //   if (!connectionOptions.length) {
  //     setConnectionOptions([t("SELECT"), ...connections]);
  //   }
  // }, [pdc]);

  useEffect(() => {
    if (listUpdated) getConnections();
    return () => { dispatch(treeActions.setPdcListUpdated({ status: false })); };
}, [listUpdated, dispatch]);
  
  useEffect(() => {
    if (isError && connectionLoading) {
      setShowAlert({ message: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
      setEnable(false);
      setLoadButton(false);
    }
   
  },[isError])
  
  const setDbColumnList = () => {
    const effectivePdcName = selectedNode?.PREDEFINED || PREDEFINED_CONNECTION;
    dispatch(api.endpoints.get_database_column_info.initiate({
      account: account,
      user: user,
      table_name: dbTable,
      pdc_name: effectivePdcName,
      schema_name: dbSchema || "",
      direction: parentScreen === "inbound" ? "IN" : "OUT",
    }, {forceRefetch : true})).then((res) => {
      if (res.data.current_state === 'SUCCESS' && isArray(res?.data?.data?.database_column_list)) {
        const dataArray = res?.data?.data?.database_column_list || [];
        setDbTableColumns(dataArray)
      } else {
        setDbTableColumns([])
      }
    }).catch((err) => {if (selectedNode?.db_table_columns.length === 0) updateHandler("DB_TABLE_COLUMNS", [])})
  }

  useEffect(() => {
    if (selectedNode?.TABLE_NAME !== dbTable ) { 
      updateHandler("TABLE_NAME", dbTable);
    setDbColumnList();
    }
  }, [dbTable]);

   useEffect(() => {
    if (selectedNode?.db_table_columns !== dbTableColumns) {
      debounceChangeHandler("DB_TABLE_COLUMNS", typeof dbTableColumns === "object" ? dbTableColumns : []);
    }
  }, [dbTableColumns])

  
  useEffect(() => {
    getConnections();
    clickedSchemaButton.current = selectedNode?.key
    setConnectionLoading(false);
    const initialConnection = selectedNode?.PREDEFINED || t("SELECT");
    setConnection(initialConnection);
    setStatementType(selectedNode?.STATEMENT || "loop_only");
    setInsertIfUpdateFails(
      ["TRUE", "true"].includes(selectedNode?.ON_STATEMENT_ERROR_FLIP)
    );
    setFieldUnchanged(["TRUE", "true"].includes(selectedNode?.UNIQUE));
    setIncludeNull(["TRUE", "true"].includes(selectedNode?.INCLUDE_NULL))

    const effectivePdcName = selectedNode?.PREDEFINED || PREDEFINED_CONNECTION;

    if (connectedPDC.CONNECTION === effectivePdcName && connectedPDC?.CONNECTION !== undefined) {
      const schemas = Object.keys(pdc?.[effectivePdcName] || {});
      setDbSchemaOptions([t('SELECT'),...schemas])
      const selectedSchema = schemas.includes(selectedNode?.SCHEMA_NAME) ? selectedNode?.SCHEMA_NAME : t('SELECT')
      setDbSchema(selectedSchema);
      // setDbSchema(selectedNode?.SCHEMA_NAME || t('SELECT'))
      selectedSchema !== t('SELECT') ? handleDatabaseTable(selectedSchema) : setDbTable(t('EMPTY_COMBO'))
      setDbTable(selectedSchema && selectedNode?.TABLE_NAME ? selectedNode?.TABLE_NAME : t('EMPTY_COMBO'))
      handleLoading(false);
      // setLoadButton(true);
      // setEnable(true);
      setColumnSorted(true);
    } else {
      if (selectedNode?.SCHEMA_NAME){
        setDbSchemaOptions([t('SELECT'), selectedNode?.SCHEMA_NAME]);
        setDbSchema(selectedNode?.SCHEMA_NAME || t('SELECT'));
        handleDatabaseTable(selectedNode?.SCHEMA_NAME)
      }
  
      if (selectedNode?.TABLE_NAME) {
        setDbTableOptions([t('EMPTY_COMBO'), selectedNode?.TABLE_NAME]);
        setDbTable(selectedNode?.TABLE_NAME);
      }
    }

    setInitialLoaded(true);
    return () => {
      setLoadButton(false);
      // setEnable(false);
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isLoading: false, isError: false}}));
    }
  }, [selectedNode?.key]);
  
  useEffect(() => {
    return () => {
      debounceChangeHandler.cancel();
    };
  }, [debounceChangeHandler]);

  return (
    <>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="statementType">{t("LBL_STATEMENT_TYPE")}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name="statementType"
          value={statementType}
          label={t("LBL_STATEMENT_TYPE")}
          onChange={handleStatementTypeChange}>
          {statementTypeOptions.map((obj, key) => (
            <MenuItem key={key} value={obj.value}>
              {obj.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {statementType !== "loop_only" && (
        <Accordion sx={styles.accordianContainer} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="accordianFieldInfo"
            className="accordian-override"
            id="accordianVCInfo"
            sx={styles.accordianHeader}>
            <SectionHeader text={t("DB_CONFIG")} />
          </AccordionSummary>
          <AccordionDetails sx={styles.accordianContainer}>
            <Stack spacing={"15px"} className="tp-segment">
              <div className="flex">
                <Autocomplete
                  freeSolo
                  size="small"
                  options={connectionOptions}
                  // disabled={connectionLoading}
                  disabled={connLoading}
                  // className="width-100"
                  value={connection}
                  inputValue={connectionInput}
                  onChange={(e, newValue) => {
                    const connectionValue =
                      typeof newValue === "string"
                        ? newValue
                        : newValue?.label || "";
                    handleChange("PREDEFINED", connectionValue);
                    setConnection(connectionValue);
                    setEnable(false);
                  }}
                  onInputChange={(event, newValue) => {
                    // const value = typeof newValue === 'string' ? newValue : '';
                    handleChange("PREDEFINED", newValue);
                    setConnectionInput(newValue);
                    if (newValue === "") setLoadButton(true);
                    setEnable(false);
                  }}
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    return typeof option === "string"
                      ? option
                      : option.label || "";
                  }}
                  sx={{ flexGrow: 2, minWidth: "140px", height: "34px" }}
                  renderInput={(params) =>
                    !enable ? (
                      <TextField
                        size="small"
                        variant="outlined"
                        {...params}
                        label={t("LBL_DATA_CONN")}
                        sx={{ height: "34px" }}
                        InputProps={{
                          ...params.InputProps,
                          sx: { height: "34px" },
                        }}
                      />
                    ) : (
                      <TextField
                        size="small"
                        variant="outlined"
                        {...params}
                        label={t("LBL_DATA_CONN")}
                        sx={{ height: "34px" }}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: "34px",
                            paddingRight: "12px !important",
                          },
                          endAdornment: (
                            <span style={{ fontSize: "15px", color: "green" }}>
                              {enable &&
                                !connectionLoading &&
                                connection &&
                                connection !== t("SELECT") && (
                                  <span className="CHECK_CIRCLE"></span>
                                )}
                            </span>
                          ),
                        }}
                      />
                    )
                  }
                />
                <LightTooltip title={t("LBL_PDC_BTN")}>
                  <Button
                    variant="outlined"
                    size="small"
                    disableElevation
                    className="margin-left-4"
                    sx={{
                      width: "40px",
                      padding: "4px 8px",
                      minWidth: "40px",
                      height: "34px",
                    }}
                    onClick={() => setPdcModal(5)}>
                    <span className="FLOWSHEET"></span>
                  </Button>
                </LightTooltip>
                <Button
                  style={{ minWidth: "180px", width: "180px", height: "34px" }}
                  variant="outlined"
                  size="small"
                  disableElevation
                  disabled={
                    connLoading ||
                    loadButton ||
                    enable ||
                    !connection ||
                    connection === t("SELECT")
                  }
                  className="width-100 margin-left-4"
                  onClick={handleConnection}>
                  {connLoading && !enable ? (
                    <CircularProgress size={"16px"} />
                  ) : (
                    !enable && t("LOAD_DATABASE_SCHEMA")
                  )}
                  {!connLoading && enable && t("SUCCESFULLY_LOADED_SCHEMA")}
                </Button>
              </div>
              <div
                className="flex align-center margin-top-12"
                style={{ flexWrap: "wrap" }}>
                <LabeledCheckbox
                  checked={columnSorted}
                  handleCheck={(checked) => {
                    setColumnSorted(checked);
                    if (selectedNode?.SORT_DB_COLUMNS !== checked)
                      debounceChangeHandler("SORT_DB_COLUMNS", checked);
                  }}
                  label={t("BTN_SORT_DB_COLUMNS")}
                />
                <LabeledCheckbox
                  checked={includeNull}
                  handleCheck={(checked) => {
                    setIncludeNull(checked);
                    if (selectedNode?.INCLUDE_NULL !== checked)
                      debounceChangeHandler("INCLUDE_NULL", checked);
                  }}
                  label={t("BTN_INCLUDE_NULL_IN_SQL")}
                />
              </div>
              {statementType !== "loop_only" &&
                statementTypeOptions.find(
                  (obj) => obj.value === statementType
                ) && (
                  <>
                    <FormControl
                      className="width-100"
                      size="small"
                      variant="outlined">
                      <Autocomplete
                        freeSolo
                        size="small"
                        options={dbSchemaOptions}
                        className="width-100"
                        value={dbSchema}
                        // autoSelect
                        onChange={handleDbSchemaChange}
                        onInputChange={(e, newVal) => {
                          setDbSchema(newVal);
                          handleDatabaseTable(newVal);
                        }}
                        getOptionLabel={(option) => {
                          if (!option) return "";
                          return typeof option === "string"
                            ? option
                            : option.label || "";
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("LBL_DATABASE_SCHEMA_OPT")}
                            // value={dbSchema || t('SELECT')}
                            onChange={handleDbSchemaChange}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                    <FormControl
                      className="width-100"
                      size="small"
                      variant="outlined">
                      <Autocomplete
                        freeSolo
                        size="small"
                        options={dbTableOptions}
                        className="width-100"
                        value={dbTable}
                        // autoSelect
                        onChange={(e, newVal) => {
                          handleDbTableChange(e, newVal);
                        }}
                        onInputChange={(e, newVal) => {
                          setDbTable(newVal);
                        }}
                        getOptionLabel={(option) => {
                          if (!option) return "";
                          return typeof option === "string"
                            ? option
                            : option.label || "";
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("LBL_TABLE_NAME")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </>
                )}
              {["INSERT", "UPDATE"].includes(statementType) && (
                <div
                  className="flex space-between align-center margin-top-16"
                  style={{ flexWrap: "wrap" }}>
                  <FormControl>
                    <TPCheckbox
                      label={
                        statementType === "UPDATE"
                          ? t("LBL_PERFORM_INSERT_IF_UPDATE_FAILS")
                          : t("LBL_PERFORM_UPDATE_IF_INSERT_FAILS")
                      }
                      checked={insertIfUpdateFails}
                      handleCheck={(checked) => {
                        setInsertIfUpdateFails(checked);
                        if (selectedNode?.ON_STATEMENT_ERROR_FLIP !== checked)
                          debounceChangeHandler(
                            "ON_STATEMENT_ERROR_FLIP",
                            checked
                          );
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TPCheckbox
                      label={t("LBL_DATABASE_UNCHANGED")}
                      checked={fieldUnchanged}
                      handleCheck={(checked) => {
                        setFieldUnchanged(checked);
                        if (selectedNode?.UNIQUE !== checked)
                          debounceChangeHandler("UNIQUE", checked);
                      }}
                    />
                  </FormControl>
                </div>
              )}
              <FormControl
                variant="outlined"
                size="small"
                className="width-100">
                <Button
                  variant="outlined"
                  size="small"
                  className="width-100"
                  startIcon={
                    <img
                      src={dbQueryIcon}
                      alt="database record"
                      style={{
                        width: 20,
                        height: 20,
                        filter:
                          "invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(40%) contrast(91%)",
                        opacity: (
                          statementType !== "loop_only"
                            ? (!dbSchema && !dbTable) ||
                              dbSchema === t("SELECT") ||
                              dbTable === t("EMPTY_COMBO")
                            : true
                        )
                          ? 0.5
                          : 1,
                      }}
                    />
                  }
                  disabled={
                    statementType !== "loop_only"
                      ? (!dbSchema && !dbTable) ||
                        dbSchema === t("SELECT") ||
                        dbSchema === "" ||
                        dbTable === t("EMPTY_COMBO") ||
                        dbTable === ""
                      : true
                  }
                  onClick={() => handleTableViewer()}>
                  {t("BTN_TABLE_VIEWER")}
                </Button>
                {/* <Button
                size="small"
                variant="outlined"
                className="width-100"
                onClick={() => setOpenTableViewer(true)}
                disabled={
                  statementType !== "loop_only"
                    ? (!dbSchema && !dbTable) ||
                      dbSchema === t("SELECT") ||
                      dbTable === t("EMPTY_COMBO")
                    : true
                }
              >
                <div style={{
                  opacity: (statementType !== "loop_only" ? (!dbSchema && !dbTable) || dbSchema === t("SELECT") || dbTable === t("EMPTY_COMBO") : true ) ? '0.6' : '1', 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span className="icon-size">
                    database
                  </span>
                  <span > {t("BTN_TABLE_VIEWER")} </span>
                </div>
              </Button> */}
              </FormControl>
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}
      <Repository
        option={pdcModal}
        setOption={setPdcModal}
        dir="OUT"
        pdcName={connection !== t("SELECT") ? connection : ""}
        handleClose={() => setPdcModal(null)}
        onPdcSelect={(selectedPdcData) => {
            // Update connection with selected PDC
            if (selectedPdcData.connectionName) {
                const connectionValue = selectedPdcData.connectionName;
                handleChange("PREDEFINED", connectionValue);
                setConnection(connectionValue);
                setEnable(false);
            }
        }}
      />
      {openTableViewer && (
        <TableViewer
          openTableViewer={openTableViewer}
          handleClose={() => setOpenTableViewer(false)}
          schema={dbSchema}
          tableName={dbTable}
          // connection={connectedPDC.CONNECTION}
          connection={selectedNode?.PREDEFINED || PREDEFINED_CONNECTION}
          setShowAlert={setShowAlert}
        />
      )}
      <Snackbar
        open={showAlert.isOpen}
        autoHideDuration={showAlert.type !== "success" ? null : 6000}
        onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ maxWidth: "500px" }}>
          {showAlert.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default DatabaseRecordProperties;
const styles = {
  accordianContainer: {
    border: "none",
    padding: "0",
    margin: "0",
    boxShadow: "none",
    backgroundColor: "unset",
  },
  accordianHeader: {
    border: "none",
    padding: "0",
    margin: "0",
    backgroundColor: "unset",
  },
  accordianContent: {
    border: "none",
    padding: "0 15px",
    margin: "0",
    backgroundColor: "unset",
  },
};